import React, { useEffect } from 'react';
import BackNavButtonContainer from '../../containers/BackNavButtonContainer';
import { WhiteHorizontalStep, StepContext } from '../WhiteHorizontalStep';
import { isApp } from '../../../../utils';
import {
  hideBackButton as hideHeaderBackButton,
  showBackButton as showHeaderBackButton,
} from '../../../../utils/AppUtils';
import './style.scss';
import EditAddressNote from '../EditAddressNote';

interface ChangeContactViewProps {
  onGoBack?: () => any;
  pageName: string;
  stepContext: StepContext;
  activeIndex: number;
  children?: any;
  hideBackButton?: boolean;
  isChangeAddress?: boolean;
}

const ChangeContactView = ({
  onGoBack,
  pageName,
  stepContext,
  activeIndex,
  children,
  hideBackButton,
  isChangeAddress,
}: ChangeContactViewProps) => {
  useEffect(() => {
    if (isApp()) {
      hideBackButton ? hideHeaderBackButton() : showHeaderBackButton();
    }
  }, [hideBackButton]);

  return (
    <div className="change-contact-view">
      <div className="change-contact">
        <div
          className={
            hideBackButton ? 'change-contact-view_back-button__hidden' : ''
          }
        >
          <BackNavButtonContainer
            onGoBack={onGoBack}
            isShowBackButton={!isApp()}
          />
        </div>
        <div className="emma-stylesheet-grid-system">
          {!isApp() && (
            <div className="change-contact-view__title">{pageName}</div>
          )}
          <div className="change-contact-view__step">
            <WhiteHorizontalStep
              stepContext={stepContext}
              activeIndex={activeIndex}
            />
          </div>
          {isChangeAddress && activeIndex === 0 && <EditAddressNote />}
        </div>
      </div>
      <div className="change-contact-view__content">
        <div className="change-contact-view__content-inner">{children}</div>
      </div>
    </div>
  );
};

ChangeContactView.defaultProps = {
  hideBackButton: false,
};

export { ChangeContactView };
